import { FunctionComponent, useRef } from 'react';
import { DraftSpecialTextConfiguration } from '@/types';
import { MaxSizeHint } from '../../MaxSizeHint';
import { SnapLines } from '../../SnapLines';
import { useConfigurationTransform } from '../../hooks/useConfigurationTransform';
import { useMoveOrEdit } from '../../hooks/useMoveOrEdit';
import { RendererProps } from '../ConfigurationRenderer';
import { ConfigurationHandlesWithZoom } from '../zoomConfigurationTest/ConfigurationHandlesWithZoom';
import { useSpecialText } from './useSpecialText';

export const SpecialTextRenderer: FunctionComponent<
  RendererProps<DraftSpecialTextConfiguration>
> = ({ configuration, viewMap, hasErrors, isSelected, onShowEdit }) => {
  const textElementRef = useRef<SVGGraphicsElement>(null);

  const {
    scale,
    maxScale,
    offset,
    rotation,
    infoText,
    isSnapTarget,
    onDelete,
    onMove,
    onPinch,
    onRotate,
    onScale,
    onSetSnapLineActive,
    snapLinesActive,
    showMaxSizeHint,
    snapLines,
  } = useConfigurationTransform(configuration, textElementRef, isSelected, true);

  const [onMoveOrEdit, onPinchOrEdit] = useMoveOrEdit(isSelected, onMove, onPinch, onShowEdit);

  const [textElement, transform] = useSpecialText(configuration, offset, rotation, scale);

  return textElement ? (
    <>
      <SnapLines viewMap={viewMap} lines={snapLines} />
      <g ref={textElementRef} transform={transform}>
        {textElement}
        <ConfigurationHandlesWithZoom
          active={isSelected}
          configuration={configuration}
          isSnapTarget={isSnapTarget}
          infoText={infoText}
          onDelete={onDelete}
          onMove={onMoveOrEdit}
          onPinch={onPinchOrEdit}
          onRotate={onRotate}
          onScale={onScale}
          scale={scale}
          viewMap={viewMap}
          onSetSnapLineActive={onSetSnapLineActive}
          snapLinesActive={snapLinesActive}
          hasConfigurationErrors={hasErrors}
        />
        <MaxSizeHint
          size={configuration.size}
          currentScale={scale}
          maxScale={maxScale}
          active={showMaxSizeHint}
        />
      </g>
    </>
  ) : null;
};
